export default {
  BRANDED: 'BRANDED',
  MULTIDESTINY: 'MULTIDESTINY',
  INTERLINE: 'INTERLINE'
}
